import { FunctionComponent } from 'react';

import { L12nText, Loader, useConfigSlice, BetLimits, BetLimitsData, useSettingsSlice } from '@pp/core';
import { formatNumber } from '@pp/core/src/utils/formatters';

import { Bets } from '../../config/bets';
export interface BetLimitsConnectedProps {}

export const BetLimitsConnected: FunctionComponent<BetLimitsConnectedProps> = () => {
  const config = useConfigSlice.tableConfig();
  const locale = useSettingsSlice.currentLanguage() || 'en';

  if (!config) {
    return <Loader />;
  }

  const betLimits = config.betLimits;

  const data: BetLimitsData = {
    tables: [
      {
        name: '',
        data: [
          [
            <L12nText tk="BETLABEL" key="1" />,
            <L12nText tk="PAYOUT" key="2" />,
            <L12nText tk="MIN" key="3" />,
            <L12nText tk="MAX" key="4" />,
          ],
          [1, '1-100:1', formatNumber(locale, betLimits[Bets.One].min), formatNumber(locale, betLimits[Bets.One].max)],
          [2, '2-200:1', formatNumber(locale, betLimits[Bets.Two].min), formatNumber(locale, betLimits[Bets.Two].max)],
          [
            5,
            '5-250:1',
            formatNumber(locale, betLimits[Bets.Five].min),
            formatNumber(locale, betLimits[Bets.Five].max),
          ],
          [
            8,
            '8-250:1',
            formatNumber(locale, betLimits[Bets.Eight].min),
            formatNumber(locale, betLimits[Bets.Eight].max),
          ],
          [
            10,
            '10-250:1',
            formatNumber(locale, betLimits[Bets.Ten].min),
            formatNumber(locale, betLimits[Bets.Ten].max),
          ],
          [
            15,
            '15-500:1',
            formatNumber(locale, betLimits[Bets.Fifteen].min),
            formatNumber(locale, betLimits[Bets.Fifteen].max),
          ],
          [
            20,
            '20-500:1',
            formatNumber(locale, betLimits[Bets.Twenty].min),
            formatNumber(locale, betLimits[Bets.Twenty].max),
          ],
          [
            30,
            '30-500:1',
            formatNumber(locale, betLimits[Bets.Thirty].min),
            formatNumber(locale, betLimits[Bets.Thirty].max),
          ],
          [
            40,
            '40-500:1',
            formatNumber(locale, betLimits[Bets.Forty].min),
            formatNumber(locale, betLimits[Bets.Forty].max),
          ],
        ],
      },
    ],
    footer: [],
  };

  return <BetLimits betLimitData={data} />;
};
